export default __webpack_public_path__ + "static/media/sb-ICO-011.cc15e10d.webp";